'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.GamingLimitDuration = exports.GamingLimitType = void 0;
/**
 * The type of gaming limit.
 * @export
 * @enum {number}
 */
var GamingLimitType;
(function (GamingLimitType) {
    GamingLimitType[GamingLimitType["DEPOSIT"] = 1] = "DEPOSIT";
    GamingLimitType[GamingLimitType["WAGERING_CASINO"] = 2] = "WAGERING_CASINO";
    GamingLimitType[GamingLimitType["NET_LOSS_CASINO"] = 3] = "NET_LOSS_CASINO";
    GamingLimitType[GamingLimitType["WAGERING_SPORTS"] = 4] = "WAGERING_SPORTS";
    GamingLimitType[GamingLimitType["NET_LOSS_SPORTS"] = 5] = "NET_LOSS_SPORTS";
    GamingLimitType[GamingLimitType["SESSION"] = 6] = "SESSION";
    GamingLimitType[GamingLimitType["STAKE_PER_SESSION"] = 7] = "STAKE_PER_SESSION";
    GamingLimitType[GamingLimitType["MAX_STAKE_PER_BET"] = 8] = "MAX_STAKE_PER_BET";
    GamingLimitType[GamingLimitType["NET_LOSS"] = 9] = "NET_LOSS";
    GamingLimitType[GamingLimitType["WAGERING"] = 10] = "WAGERING";
})(GamingLimitType = exports.GamingLimitType || (exports.GamingLimitType = {}));
/**
 * Durations for the gaming limits
 * @export
 * @enum {number}
 */
var GamingLimitDuration;
(function (GamingLimitDuration) {
    GamingLimitDuration[GamingLimitDuration["ONE_DAY"] = 1] = "ONE_DAY";
    GamingLimitDuration[GamingLimitDuration["ONE_WEEK"] = 2] = "ONE_WEEK";
    GamingLimitDuration[GamingLimitDuration["ONE_MONTH"] = 3] = "ONE_MONTH";
    GamingLimitDuration[GamingLimitDuration["THREE_MONTHS"] = 4] = "THREE_MONTHS";
    GamingLimitDuration[GamingLimitDuration["NONE"] = 5] = "NONE";
    GamingLimitDuration[GamingLimitDuration["SESSION"] = 6] = "SESSION";
})(GamingLimitDuration = exports.GamingLimitDuration || (exports.GamingLimitDuration = {}));
